<script>
// WB-M1A -- the board toolbar's own small glyph set, the same functional
// component shape as StudentHomeIcon. Kept local so the accepted icon set is
// not extended by the Workspace.
const SHAPES = {
  selection: [{ tag: 'path', d: 'm5 3 5.2 16 2.4-6.4L19 10.2Z' }],
  // P42-01: the toolbar's Selection tool. It selects, moves, resizes and
  // rotates board elements -- it is NOT a crop -- so its glyph is a dashed
  // selection area with the pointer on its corner.
  selectArea: [
    { tag: 'rect', x: 3, y: 3, width: 14, height: 14, rx: 2, dash: '2.4 2.6' },
    { tag: 'path', d: 'm13 13 8 3-3.5 1.5L16 21Z' },
  ],
  // P42-02: Send -- the prototype's paper plane (`ICON.send`).
  send: [
    { tag: 'path', d: 'm21 3-18 9 18 9-4-9Z' },
    { tag: 'path', d: 'M17 12H3' },
  ],
  freedraw: [
    { tag: 'path', d: 'M12 20h9' },
    { tag: 'path', d: 'M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z' },
  ],
  eraser: [
    {
      tag: 'path',
      d:
        'm7 21-4.3-4.3a1 1 0 0 1 0-1.4l10-10a1 1 0 0 1 1.4 0l5.6 5.6a1 1 0 0 1 0 1.4L13 19',
    },
    { tag: 'path', d: 'M22 21H7' },
    { tag: 'path', d: 'm5 11 9 9' },
  ],
  text: [
    { tag: 'path', d: 'M4 7V4h16v3' },
    { tag: 'path', d: 'M9 20h6' },
    { tag: 'path', d: 'M12 4v16' },
  ],
  rectangle: [{ tag: 'rect', x: 3, y: 5, width: 18, height: 14, rx: 2 }],
  ellipse: [
    { tag: 'path', d: 'M12 5c5 0 9 3.1 9 7s-4 7-9 7-9-3.1-9-7 4-7 9-7Z' },
  ],
  line: [{ tag: 'path', d: 'M5 19 19 5' }],
  arrow: [
    { tag: 'path', d: 'M5 19 19 5' },
    { tag: 'path', d: 'M10 5h9v9' },
  ],
  undo: [
    { tag: 'path', d: 'M9 14 4 9l5-5' },
    { tag: 'path', d: 'M4 9h10.5a5.5 5.5 0 0 1 0 11H11' },
  ],
  redo: [
    { tag: 'path', d: 'm15 14 5-5-5-5' },
    { tag: 'path', d: 'M20 9H9.5a5.5 5.5 0 0 0 0 11H13' },
  ],
  resetView: [
    { tag: 'path', d: 'M4 9V4h5' },
    { tag: 'path', d: 'M20 9V4h-5' },
    { tag: 'path', d: 'M4 15v5h5' },
    { tag: 'path', d: 'M20 15v5h-5' },
    { tag: 'circle', cx: 12, cy: 12, r: 2 },
  ],
  chevron: [{ tag: 'path', d: 'm9 6 6 6-6 6' }],
  // P41 BT-54: «پاک کردن همهٔ تخته» -- a bin.
  clear: [
    { tag: 'path', d: 'M4 7h16' },
    { tag: 'path', d: 'M10 11v6' },
    { tag: 'path', d: 'M14 11v6' },
    { tag: 'path', d: 'M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12' },
    { tag: 'path', d: 'M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2' },
  ],
  // WB-M2A: «از AI Tutor بپرس» -- a speech bubble with the tutor's spark.
  askTutor: [
    {
      tag: 'path',
      d:
        'M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H10l-4.5 4v-4A1.5 1.5 0 0 1 4 14.5Z',
    },
    { tag: 'path', d: 'm12 6.5.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1L9 9.5l2.1-.9z' },
  ],
  // WB-M2A: the «از تخته» badge in the conversation.
  board: [
    { tag: 'rect', x: 3, y: 4, width: 18, height: 13, rx: 2 },
    { tag: 'path', d: 'M8 21h8' },
    { tag: 'path', d: 'M12 17v4' },
    { tag: 'path', d: 'm7 13 3-4 2.5 3 1.5-2 3 3' },
  ],
  // POST-UAT-UX / PUX-B (doc 35/01 §2.1): the main Chat composer's Board
  // entry, exactly the rendered V405 `.borna-whiteboard-trigger` glyph.
  boardEntry: [
    { tag: 'rect', x: 3, y: 4, width: 18, height: 13, rx: 2 },
    { tag: 'path', d: 'M8 20h8' },
    { tag: 'path', d: 'M12 17v3' },
    { tag: 'path', d: 'M7 8h10' },
  ],
}

function shapeAttrs(shape) {
  switch (shape.tag) {
    case 'circle':
      return { cx: shape.cx, cy: shape.cy, r: shape.r }
    case 'rect':
      return {
        x: shape.x,
        y: shape.y,
        width: shape.width,
        height: shape.height,
        rx: shape.rx,
        ...(shape.dash ? { 'stroke-dasharray': shape.dash } : {}),
      }
    default:
      return { d: shape.d }
  }
}

export default {
  name: 'BoardIcon',
  functional: true,
  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 20 },
  },
  render(h, { props }) {
    const shapes = SHAPES[props.name]
    if (!shapes) return null
    return h(
      'svg',
      {
        attrs: {
          width: props.size,
          height: props.size,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': 1.8,
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'aria-hidden': 'true',
          focusable: 'false',
        },
      },
      shapes.map(shape => h(shape.tag, { attrs: shapeAttrs(shape) }))
    )
  },
}
</script>
